import { BaseRestfulService } from "./base";
import { ServiceURL } from "./url";

export class RegisterService extends BaseRestfulService {
    async request({cellphone}) {
        return this.post(ServiceURL.register.request(), {
            cellphone,
        });
    }

    async register(data) {
        return this.post(ServiceURL.register.register(), data);
    }
}
